<ng-container *ngIf="hasConflicts">
  <session-conflict *ngFor="let conflict of conflicts" [conflict]="conflict" [sessionId]="sessionId"></session-conflict>
</ng-container>

<confirm-delete-with-input *ngIf="!hasConflicts" />
